var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 5.7L7.83696 10.2543C7.85736 10.2735 7.88242 10.2889 7.91049 10.2994C7.93856 10.3099 7.96899 10.3154 7.99978 10.3154C8.03057 10.3154 8.06101 10.3099 8.08908 10.2994C8.11715 10.2889 8.14221 10.2735 8.16261 10.2543L13 5.7",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0c142825acc4a75999dff0b5f9be7522.svg";
export { ForwardRef as ReactComponent };